import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { useState } from 'react';

import { JustifyContentType, gridSize } from '@/shared/constants';

export interface SampleCheckboxNoFormProps {
  label: string;
  labelPlacement?: "end" | "start" | "top" | "bottom" ;
  onChangeValue?: (e?: boolean) => void;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  defaultValue?: boolean;
  disabled?: boolean;
  justifyContent?: JustifyContentType;
  alignItems?: JustifyContentType;
  sizeCheck?: "small" | "large" | "medium";

  icon?: React.ReactNode;
  checkedIcon?: React.ReactNode;

  overrideChecked?: boolean;
  cssLabel?: React.CSSProperties | undefined
}

const SampleCheckboxNoForm: React.FC<SampleCheckboxNoFormProps> = ({
  label,
  labelPlacement = "end",
  onChangeValue,
  defaultValue = false,
  size = gridSize,
  disabled = false,
  alignItems,
  justifyContent,
  icon,
  checkedIcon = <CheckBoxIcon />,
  overrideChecked = false,
  sizeCheck = "small",
  cssLabel,
}) => {
  const [checked, setChecked] = useState(defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled || overrideChecked) return;

    setChecked(event.target.checked);
    onChangeValue && onChangeValue(event.target.checked);
  };

  return (
    <Grid
      item
      {...size}
      container
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <FormControlLabel
      sx={{width:"100%"}}
        label={<Typography style={{
          color: '#6C737F',
          ...cssLabel
        }}>
          {label}
        </Typography>}
        labelPlacement={labelPlacement}
        control={
          <Checkbox
            // checked={checked}
            {...(!overrideChecked && { checked })}
            onChange={handleChange}
            size={sizeCheck}
            // disabled={disabled}
            // conditional render
            checkedIcon={icon ?? checkedIcon}
            {...(icon && { icon })}
            sx={{
              color: 'primary.main',
            }}
          />
        }
      />
    </Grid>
  );
};

export default SampleCheckboxNoForm;
